
import { defineComponent } from 'vue'
import RequestDueDate from './request-duedate.vue'
import RequestFulfillmentDate from './request-fulfillment-date.vue'
import RequestReceivedDate from './request-received-date.vue'
import { mapState } from 'vuex'
import RequestExpirationDate from './request-expiration-date.vue'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation/nr-loading-animation.vue'

export default defineComponent({
  name: 'request-dates',
  components: {
    RequestFulfillmentDate,
    RequestDueDate,
    RequestReceivedDate,
    RequestExpirationDate,
    NrLoadingAnimation
  },
  props: {
    prettyId: {
      type: String,
      required: true
    },
    canSeeRequestDueDate: {
      type: Boolean
    },
    dueDate: {
      type: String
    },
    received: {
      type: String
    },
    canSeeRequestExpirationDate: {
      type: Boolean
    },
    exemptFromRetention: {
      type: Boolean
    },
    fulfillment: {
      type: String
    },
    expiration: {
      type: String
    },
    requestSubmitType: {
      type: String
    }
  },
  computed: {
    ...mapState(['account']),
    ...mapState('request_show', ['filteredRequestLoading']),
    canSeeFulfillmentDate() {
      return (
        this.$can('read', 'staff_only_items') &&
        this.account.anticipated_fulfillment_date
      )
    }
  }
})
